import { useEffect, useState } from "react";

const STORAGE_KEY = "bedrock.motionHistoryLayout";
export const MOTION_HISTORY_LAYOUT_EVENT = "bedrock:motion-history-layout";

export const LAYOUT_ENHANCED = "enhanced";
export const LAYOUT_LEGACY = "legacy";

/** Default: 2-column grid + hour group headings */
export function getMotionHistoryLayout() {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === LAYOUT_LEGACY) return LAYOUT_LEGACY;
    } catch (e) {
        /* ignore */
    }
    return LAYOUT_ENHANCED;
}

export function setMotionHistoryLayout(layout) {
    const next = layout === LAYOUT_LEGACY ? LAYOUT_LEGACY : LAYOUT_ENHANCED;
    try {
        localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
        /* ignore */
    }
    window.dispatchEvent(new CustomEvent(MOTION_HISTORY_LAYOUT_EVENT, { detail: next }));
    return next;
}

export function toggleMotionHistoryLayout() {
    const next =
        getMotionHistoryLayout() === LAYOUT_LEGACY ? LAYOUT_ENHANCED : LAYOUT_LEGACY;
    return setMotionHistoryLayout(next);
}

export function isEnhancedMotionHistoryLayout(layout = getMotionHistoryLayout()) {
    return layout !== LAYOUT_LEGACY;
}

export function subscribeMotionHistoryLayout(callback) {
    const handler = (e) => callback(e.detail ?? getMotionHistoryLayout());
    window.addEventListener(MOTION_HISTORY_LAYOUT_EVENT, handler);
    return () => window.removeEventListener(MOTION_HISTORY_LAYOUT_EVENT, handler);
}

export function useMotionHistoryLayout() {
    const [layout, setLayout] = useState(getMotionHistoryLayout);

    useEffect(() => subscribeMotionHistoryLayout(setLayout), []);

    return layout;
}
